import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateChildModule } from '../../helpers/translations/translate-child.module';

import { CaasMondayWebformsComponent } from './caas-monday-webforms.component';
import { SewRichtTextDirective } from './form-controls/sew-richt-text.directive';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TranslateChildModule,
        CaasMondayWebformsComponent,
        SewRichtTextDirective,
    ],
    exports: [CaasMondayWebformsComponent],
})
/**
 * FormBuilder needs to be provided in the root of the consuming application as it's a singleton now and DI is providing it in root.
 * It was previously provided in the ReactiveFormsModule
 * This is badly documented in angular, but you can check out this resources:
 *
 * - https://github.com/angular/angular/commit/02691a74bb9889bae42f1c1c37b70c946f322dd5
 * - https://github.com/angular/angular/issues/48237
 * - https://stackoverflow.com/questions/67888232/angular-service-providedin-root-imported-from-library-throws-nullinjectorerror
 */
export class CaasMondayWebformsModule {}
